import React, { Fragment } from 'react';
import { string } from 'prop-types';
import Head from 'next/head';

function AmpRedditEmbed({ url }) {
  return (
    <Fragment>
      <Head>
        <script
          async
          custom-element="amp-reddit"
          key="amp-reddit-embed"
          src="https://cdn.ampproject.org/v0/amp-reddit-0.1.js"
        />
      </Head>
      <amp-layout className="AmpReddit" width="345" height="380" layout="fixed">
        <amp-reddit
          layout="fixed"
          width="345"
          height="380"
          data-embedtype="post"
          data-src={url}
        />
      </amp-layout>
    </Fragment>
  );
}

AmpRedditEmbed.propTypes = {
  url: string
};

AmpRedditEmbed.defaultProps = {
  url: undefined
};

export default AmpRedditEmbed;
